import { locationSlugs, termSlugs } from '@src/constants';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { getParamsForSlug, getSEOParamsForSlug } from '@src/seo/getJobDbPages';
import SEOTags from '@components/SEOTags';
import { isLocationSlug, isTermSlug } from '@src/helpers/seo';
import ProgrammaticPage from '@/pagecomponents/ProgrammaticPage';
import axios from 'axios';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

const NavBar = dynamic(() => import('@/pagecomponents/newcomponents/Navbar'))

export default function JobPage({ staticJobs, staticParams, seoParams, slug }) {
    console.log(seoParams)
    const router = useRouter();

    if (router.isFallback) {
      // Keep this markup SIMPLE and stable
      return <div suppressHydrationWarning>Loading…</div>;
    }

    return (
          <div>
            <NavBar secondary />
            <ProgrammaticPage 
              jobsData={staticJobs}
              pageTitle={seoParams?.pageTitle}
              location={isLocationSlug(slug) ? slug : null}
              term={isTermSlug(slug) ? slug : null}              
            />
            <SEOTags 
              title={seoParams?.title} 
              description={seoParams?.description} 
              url={`https://www.lifeshack.com/jobs/${slug}/`}
              noFollow={seoParams?.noFollow}
            />
          </div>
      )
}

export async function getStaticPaths({ locales }) {
  try {
    const paths = []
    const slugs = [
      ...termSlugs.map((term) => term.slug),
      ...locationSlugs.map((term) => term.slug),
      "search"
    ]

    console.log(`Generating ${slugs.length} pages:`)
    slugs.forEach((slug, index) => {
      console.log(`${index + 1}: ${slug}`)
    })

    console.log('Total slugs to generate:', slugs.length)
    console.log('Last few slugs:', slugs.slice(-5)) // Log the last 5 slugs

    // Generate paths for each locale
    if (locales) {
      locales.forEach(locale => {
        slugs.forEach(slug => {
          paths.push({
            params: { slug },
            locale // Add locale to each path
          })
        })
      })
    } else {
      // Fallback if no locales
      slugs.forEach(slug => {
        paths.push({ params: { slug } })
      })
    }

    return { paths, fallback: false }
  } catch (error) {
    console.log('error with static paths: ', error)
    return { paths: [], fallback: false }
  }
}


export async function getStaticProps(context) {
  const { slug } = context.params;
  console.log('getStaticProps context:', context);

  if (!slug || (slug !== "search" && !isLocationSlug(slug) && !isTermSlug(slug))) {
    return {
      notFound: true
    }
  }
  

  if (slug === "search") {
    return {
      props: {
        staticJobs: [],
        staticParams: {},
        seoParams: {
          title: `Search for jobs on Lifeshack`,
          pageTitle: 'Job Search | LifeShack',
          description: `Search for jobs on LifeShack`, 
          url: `https://www.lifeshack.com/jobs/search/`,
          type: 'website', 
          image: null, 
          noFollow: true
        },
        slug
      },
      revalidate: 86400
    }
  }
  
  try {
    const jobs = await getJobsForSlug(slug)
    const params = await getParamsForSlug(slug)
    const seoParams = await getSEOParamsForSlug(slug)
    const staticJobs = Array.isArray(jobs) ? jobs : []
  
    return {
      props: {
        staticJobs,
        staticParams: params || {}, // Add fallback
        seoParams: {
          ...seoParams,
          noFollow: staticJobs.length === 0,
        },
        slug
      },
      revalidate: 86400
    }
  } catch (error) {
    console.log('error getting static props: ', error)
    return {
      notFound: true,
    }
  }
}

async function getJobsForSlug(slug) {
    if (slug === "search") {
      return []
    }

    if (isTermSlug(slug)) {
      try {
        const response = await axios.get(`${baseUrl}/api/jobs/`, {
          params: {
            term: slug,
          }
        });
        // console.log('response from jobs api: ', response.data)
        return response.data || [];
      } catch (error) {
        console.error('Error fetching jobs by location:', error);
        return [];
      }      
    }

    if (isLocationSlug(slug)) {
      try {
        const response = await axios.get(`${baseUrl}/api/jobs/`, {
          params: {
            city: slug,
          }
        });
        return response.data || [];
      } catch (error) {
        console.error('Error fetching jobs by location:', error);
        return [];
      }
    }

    return [];
}

JobPage.getLayout = (page) => {
    return <>{page}</>
}
